import React, { useState, useEffect } from 'react';

import { useForm, useStep } from 'react-hooks-helper';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';

import { useGlobalState, percentCalc } from '../../../../contexts/globalState';
import { TimesArrayContext } from '../../../../contexts/TimesArray';

import styles from '../../Forms.scss';

import GetComponent from './Steps';

const ADD_TOUR = gql`
  mutation createTours($tour: TourInput!) {
    createTours(TourInput: $tour) {
      id
    }
  }
`;

const defaultData = {
  requestorName: '',
  requestorTitle: '',
  requestorTeam: '',
  requestorEmail: '',
  requestorPhone: '',
  requestorCompany: '',
  sponsorName: '',
  sponsorTitle: '',
  sponsorTeam: '',
  sponsorEmail: '',
  tourType: '',
  tourTypeName: '',
  tourPurpose: '',
  numAttendees: '',
  catering: '',
  tourContact: '',
  tourContactName: '',
  tourContactEmail: '',
  tourContactPhone: '',
  tourNeeded: '',
  notes: '',
  type: 'event',
};

const defaultDataFilled = {
  requestorName: 'John Doe',
  requestorTitle: 'Title',
  requestorTeam: 'Team',
  requestorEmail: 'requestor@email.com',
  requestorPhone: '4160000000',
  requestorCompany: 'HP',
  sponsorName: '',
  sponsorTitle: '',
  sponsorTeam: '',
  sponsorEmail: '',
  tourType: 'internal',
  tourTypeName: 'Visiting Group Name',
  tourPurpose: 'Media Event',
  numAttendees: '12',
  catering: 'yes',
  tourContact: 'no',
  tourContactName: 'Tara Devine',
  tourContactEmail: 'tara@email.com',
  tourContactPhone: '4160000000',
  tourNeeded: '',
  notes: 'This is notes',
  type: 'event',
};
const MultiStepEventForm = () => {
  const [addTour, { data }] = useMutation(ADD_TOUR);
  const timesArray = React.useContext(TimesArrayContext);
  const [currentStep, setCurrentStep] = useGlobalState('currentStep');
  const [paginationStep, setPaginationStep] = useGlobalState('steps');

  const [formData, setForm] = useForm(
    process.env.NODE_ENV === 'development' ? defaultDataFilled : defaultData,
  );
  const [dateTime, setDateTime] = useState();
  const [formDataAll, setFormDataAll] = useState();

  const submitFormHandler = () => {
    return addTour({
      variables: { tour: formDataAll },
    });
  };

  const baseSteps = [
    {
      component: 'DateTime',
      props: { dateTime, setDateTime, timesArray },
    },
    {
      component: 'ReqInfo',
      props: { dateTime, setDateTime, timesArray },
    },
    { component: 'TypeOfTour' },
    { component: 'TourPurpose' },
    { component: 'NumAttendees' },
    { component: 'Catering' },
    { component: 'TourContact' },
    { component: 'TourGuideNeeded' },
    { component: 'Notes' },
    { component: 'Terms' },
    { component: 'ReviewForm', props: { submitFormHandler, dateTime } },
    { component: 'SubmissionForm' },
  ];

  const stepsArr = baseSteps.map((stepConfig, id) => ({
    id,
    ...stepConfig,
  }));

  const { index, step, navigation } = useStep({
    initialStep: 0,
    steps: stepsArr,
  });

  useEffect(() => {
    setPaginationStep(stepsArr.length - 2);
    setCurrentStep(index + 1);
    setFormDataAll({ ...formData, dateTime });
    percentCalc(stepsArr.length - 2, index + 1);
    // console.log('dateTime', dateTime);
    // console.table('formDataAll', { ...formData, dateTime });
  }, [formData, dateTime, index]);

  const props = {
    formData,
    setForm,
    navigation,
    step,
    index,
  };
  const compIndex = stepsArr.findIndex(s => s.id === index);
  const isSubmissionStep = stepsArr[compIndex].component === 'SubmissionForm';

  return (
    <div
      className={
        isSubmissionStep
          ? `${styles.form} ${styles.form__wide}`
          : styles.form
      }
    >
      {GetComponent(stepsArr[compIndex].component, {
        ...props,
        ...stepsArr[compIndex].props,
      })}
    </div>
  );
};

export default MultiStepEventForm;
